module.exports = "./img/6d1d2944fa83bcdcd48a132b57c7c3af.jpg";